import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTeam } from '../contexts/TeamContext';
import { LoadingSpinner } from './LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { teams, loading: teamLoading, initialLoadComplete } = useTeam();
  const location = useLocation();

  if (authLoading) {
    return <LoadingSpinner fullScreen message="読み込み中..." />;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // ログイン済みだがチーム情報がまだ読み込まれていない場合
  if (teamLoading || !initialLoadComplete) {
    return <LoadingSpinner fullScreen message="読み込み中..." />;
  }

  // チーム選択画面以外で、チームがない場合はチーム選択画面へ
  if (teams.length === 0 && location.pathname !== '/team-selection') {
    return <Navigate to="/team-selection" />;
  }

  // チーム選択画面で、既にチームがある場合はホーム画面へ
  if (teams.length > 0 && location.pathname === '/team-selection') {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};
